import React from 'react';
import { List, Grid } from 'semantic-ui-react';

import {
    CalibrationId,
    Calibration,
    EquipmentSetId
} from 'services/equipmentSets/types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectCalibration } from 'services/equipmentSets/selectors';
import { AppState } from 'services/types';
import {
    SprayEntityIds,
    SprayApplicationRate
} from 'services/sprayEvents/types';
import { formatPressureUnit } from 'services/equipmentSets/utils';
import ListItem from 'components/ListItem';
import SprayEventTypeWeedGate from 'components/SprayEventTypeWeedGate';
import SprayEventTypeCropGate from 'components/SprayEventTypeCropGate';

interface OwnProps {
    calibrationId?: CalibrationId;
    equipmentSetId?: EquipmentSetId;
    entityIds?: SprayEntityIds;
    applicationRate?: SprayApplicationRate;
}

interface ConnectedProps {
    calibration?: Calibration;
}

export type Props = ConnectedProps & OwnProps;

export class DetailsComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { calibration, equipmentSetId } = this.props;

        if (calibration) {
            const {
                rowSpacingMax,
                rowSpacingMin,
                flowRate,
                fanSpeed,
                gaugePressure,
                pressureUnit,
                engineRpm,
                speed,
                gear,
                swathWidth,
                nozzlesPerSide
            } = calibration;

            const formattedPressureUnit = formatPressureUnit(pressureUnit);

            return (
                <Grid.Row>
                    <Grid.Column>
                        <div className="calibration-details">
                            <List>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <ListItem
                                                description="Row range"
                                                value={`${rowSpacingMin} - ${rowSpacingMax}m`}
                                            />
                                        </Grid.Column>
                                        <Grid.Column
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <ListItem
                                                description="Gear"
                                                value={gear}
                                            />
                                        </Grid.Column>
                                        <Grid.Column
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <ListItem
                                                description="Speed"
                                                value={`${speed} km/h`}
                                            />
                                        </Grid.Column>
                                        <Grid.Column
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <ListItem
                                                description="Flow rate"
                                                value={`${flowRate} l/min`}
                                            />
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row>
                                        <Grid.Column
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <ListItem
                                                description="Pressure"
                                                value={`${gaugePressure}${
                                                    formattedPressureUnit &&
                                                    ` ${formattedPressureUnit}`
                                                }`}
                                            />
                                        </Grid.Column>
                                        <Grid.Column
                                            mobile={8}
                                            computer={4}
                                            tablet={4}
                                        >
                                            <ListItem
                                                description="Engine RPM"
                                                value={`${engineRpm} RPM`}
                                            />
                                        </Grid.Column>
                                        <SprayEventTypeWeedGate>
                                            <React.Fragment>
                                                <Grid.Column
                                                    mobile={8}
                                                    computer={4}
                                                    tablet={4}
                                                >
                                                    <ListItem
                                                        description="Swath width"
                                                        value={`${swathWidth}m`}
                                                    />
                                                </Grid.Column>
                                                <Grid.Column
                                                    mobile={8}
                                                    computer={4}
                                                    tablet={4}
                                                >
                                                    <ListItem
                                                        description="Nozzles/Side"
                                                        value={nozzlesPerSide}
                                                    />
                                                </Grid.Column>
                                            </React.Fragment>
                                        </SprayEventTypeWeedGate>
                                        <SprayEventTypeCropGate>
                                            <Grid.Column
                                                mobile={8}
                                                computer={4}
                                                tablet={4}
                                            >
                                                <ListItem
                                                    description="Fan speed"
                                                    value={fanSpeed}
                                                />
                                            </Grid.Column>
                                        </SprayEventTypeCropGate>
                                    </Grid.Row>
                                </Grid>
                            </List>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            );
        }

        if (!equipmentSetId) {
            return (
                <Grid.Row>
                    <Grid.Column>
                        <div className="calibration-details">
                            <p>
                                You must select an equipment set to load
                                calibration details
                            </p>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            );
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, ConnectedProps>({
    calibration: makeSelectCalibration()
});

export default connect(mapStateToProps)(DetailsComponent);
